import React from 'react';
import ReactDOM from 'react-dom';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import './index.css';

// eslint-disable-next-line no-extend-native
Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + (h*60*60*1000));
  return this;
}

export default class TherapistDateFilter extends React.Component {
	constructor(props) {
		super(props);
		this.handleDayChange = this.handleDayChange.bind(this);

		//default value
		var dates = undefined;

		//read url query
		var urlParams = new URLSearchParams(window.location.search);
		if ( urlParams.has('dates') && isValidDate( urlParams.get('dates') ) ){
			dates = new Date( urlParams.get('dates') );
		}

		

		this.state = {
			selectedDay: dates,
		};
	}

	handleDayChange(day) {
		this.setState({ selectedDay: day });
	}

	render() {
		const selectedDay = (this.state.selectedDay ? this.state.selectedDay.toISOString().slice(0,10): '');

		return (
			<DayPickerInput 
				format="YYYY-MM-DD"
				onDayChange={this.handleDayChange} 
				dayPickerProps={{
					disabledDays : { before: new Date().addHours(24) },
					fromMonth : new Date().addHours(5),

				}}
				value={selectedDay} 
				placeholder="Select date"
				inputProps={{
					id: 'dates',
					name: 'dates',
					className: 'form-control',
					autoComplete: 'off'
				}}
			/>
		);
	}
}

ReactDOM.render(
	<TherapistDateFilter />,
	document.getElementById('TherapistDateFilter')
	);

function isValidDate(dateString) {
  var regEx = /^\d{4}-\d{2}-\d{2}$/;
  if(!dateString.match(regEx)) return false;  // Invalid format
  var d = new Date(dateString);
  var dNum = d.getTime();
  if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return d.toISOString().slice(0,10) === dateString;
}